/* Ghost costume product page behaviour.
   Every initialiser is idempotent (safe if this file is included by several
   sections) and re-runs on theme-editor section loads. */
(function () {
  'use strict';

  if (window.__gcPageLoaded) return;
  window.__gcPageLoaded = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function once(el, key) {
    if (el.dataset[key] === '1') return false;
    el.dataset[key] = '1';
    return true;
  }

  /* -------------------------------------------------------------- video */

  function bindLoopVideo(wrap, toggle) {
    var video = wrap.querySelector('video');
    if (!video) return;
    video.muted = true;
    video.setAttribute('playsinline', '');

    function setState(paused) {
      wrap.classList.toggle('is-paused', paused);
      if (toggle) toggle.setAttribute('aria-label', paused ? toggle.dataset.labelPlay : toggle.dataset.labelPause);
    }

    function tryPlay() {
      var p = video.play();
      if (p && typeof p.then === 'function') {
        p.then(function () { setState(false); }).catch(function () { setState(true); });
      }
    }

    if (reduceMotion) {
      video.removeAttribute('autoplay');
      video.pause();
      setState(true);
    } else {
      tryPlay();
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        if (video.paused) { tryPlay(); } else { video.pause(); setState(true); }
      });
    }
  }

  /* ------------------------------------------------------------ gallery */

  function initGallery(root) {
    each(root.querySelectorAll('[data-gc-gallery]'), function (gal) {
      if (!once(gal, 'gcGal')) return;
      var track = gal.querySelector('[data-gc-track]');
      var slides = gal.querySelectorAll('[data-gc-slide]');
      var thumbs = gal.querySelectorAll('[data-gc-thumb]');
      var dots = gal.querySelectorAll('[data-gc-dot]');
      if (!track) return;

      each(gal.querySelectorAll('[data-gc-video-slide]'), function (slide) {
        bindLoopVideo(slide, slide.querySelector('[data-gc-vtoggle]'));
      });

      function mark(i) {
        each(thumbs, function (t) { t.setAttribute('aria-current', String(Number(t.dataset.gcThumb) === i)); });
        each(dots, function (d) { d.setAttribute('aria-current', String(Number(d.dataset.gcDot) === i)); });
      }

      each(thumbs, function (t) {
        t.addEventListener('click', function () {
          var i = Number(t.dataset.gcThumb);
          var target = slides[i];
          if (!target) return;
          track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
          mark(i);
        });
      });

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          mark(i);
          ticking = false;
        });
      }, { passive: true });

      track.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        track.scrollBy({ left: (e.key === 'ArrowRight' ? 1 : -1) * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });
  }

  /* -------------------------------------------------- packs & buy box */

  function initBuyBox(root) {
    each(root.querySelectorAll('[data-gc-main]'), function (main) {
      if (!once(main, 'gcMain')) return;
      var form = main.querySelector('[data-gc-form]');
      var dataEl = main.querySelector('[data-gc-prices]');
      if (!form || !dataEl) return;

      var data;
      try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var packs = form.querySelectorAll('[data-gc-pack]');
      var variantEl = form.querySelector('[data-gc-variant]');
      var submit = form.querySelector('[data-gc-submit]');
      var unit = main.querySelector('[data-gc-unit]');
      var stickyPrice = main.querySelector('[data-gc-sticky-price]');

      function current() {
        for (var i = 0; i < packs.length; i++) if (packs[i].checked) return i;
        return 0;
      }

      function render() {
        var v = data.variants[variantEl ? variantEl.value : ''];
        if (!v) return;
        var idx = current();
        var total = packs.length && v.packs[idx] ? v.packs[idx].total : v.unit;

        each(packs, function (input, i) {
          var card = input.closest('.gc-pack');
          var p = v.packs[i];
          if (!card || !p) return;
          card.querySelector('[data-gc-total]').textContent = p.total;
          var was = card.querySelector('[data-gc-was]');
          var save = card.querySelector('[data-gc-save]');
          was.textContent = p.compare;
          was.hidden = !p.hasSaving;
          save.hidden = !p.hasSaving;
          save.querySelector('[data-gc-save-amt]').textContent = p.saved;
        });

        if (unit) unit.textContent = v.unit;
        if (stickyPrice) stickyPrice.textContent = total;

        if (submit) {
          submit.innerHTML = '';
          if (v.available) {
            submit.disabled = false;
            var a = document.createElement('span'); a.textContent = data.buttonLabel;
            var s = document.createElement('span'); s.className = 'gc-buy__sep'; s.setAttribute('aria-hidden', 'true'); s.textContent = '·';
            var b = document.createElement('span'); b.textContent = total;
            submit.appendChild(a); submit.appendChild(s); submit.appendChild(b);
          } else {
            submit.disabled = true;
            submit.textContent = data.soldOut;
          }
        }
      }

      each(packs, function (p) { p.addEventListener('change', render); });
      if (variantEl && variantEl.tagName === 'SELECT') variantEl.addEventListener('change', render);
      render();

      // Sticky bar: show once the main button has scrolled out of view.
      var sticky = main.querySelector('[data-gc-sticky]');
      if (sticky && submit && 'IntersectionObserver' in window) {
        var btn = sticky.querySelector('button');
        var io = new IntersectionObserver(function (entries) {
          var off = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
          sticky.classList.toggle('is-on', off);
          sticky.setAttribute('aria-hidden', String(!off));
          if (btn) btn.tabIndex = off ? 0 : -1;
        });
        io.observe(submit);
      }
    });
  }

  /* --------------------------------------------- delivery date estimate */

  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }

  function initEta(root) {
    each(root.querySelectorAll('[data-gc-eta]'), function (el) {
      if (!once(el, 'gcEta')) return;
      var min = parseInt(el.dataset.min, 10);
      var max = parseInt(el.dataset.max, 10);
      var out = el.querySelector('[data-gc-eta-dates]');
      if (!out || isNaN(min) || isNaN(max)) return;
      if (max < min) { var t = min; min = max; max = t; }
      try {
        var fmt = new Intl.DateTimeFormat(document.documentElement.lang || undefined, { month: 'short', day: 'numeric' });
        var now = new Date();
        out.textContent = fmt.format(addBusinessDays(now, min)) + ' – ' + fmt.format(addBusinessDays(now, max));
      } catch (e) { /* keep fallback text */ }
    });
  }

  /* ------------------------------------------------- before/after slider */

  function initCompare(root) {
    each(root.querySelectorAll('[data-gc-compare]'), function (el) {
      if (!once(el, 'gcCmp')) return;
      var range = el.querySelector('input[type="range"]');
      if (!range) return;
      var apply = function () { el.style.setProperty('--pos', range.value + '%'); };
      range.addEventListener('input', apply);
      apply();
    });
  }

  /* ---------------------------------------------------------- demo video */

  function initDemo(root) {
    each(root.querySelectorAll('[data-gc-demo]'), function (frame) {
      if (!once(frame, 'gcDemo')) return;
      var btn = frame.querySelector('[data-gc-demo-play]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var embed = btn.dataset.embed;
        if (embed) {
          var iframe = document.createElement('iframe');
          iframe.src = embed;
          iframe.title = btn.getAttribute('aria-label') || 'Video';
          iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
          iframe.setAttribute('allowfullscreen', '');
          frame.appendChild(iframe);
        } else {
          var video = frame.querySelector('video');
          if (video) {
            video.controls = true;
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
          }
        }
        var poster = frame.querySelector('[data-gc-demo-poster]');
        if (poster) poster.remove();
        btn.remove();
      });
    });
  }

  /* ----------------------------------------------------- loop videos */

  function initLoops(root) {
    each(root.querySelectorAll('[data-gc-loop]'), function (wrap) {
      if (!once(wrap, 'gcLoop')) return;
      bindLoopVideo(wrap, wrap.querySelector('[data-gc-vtoggle]'));
    });
  }

  /* ------------------------------------------------------- accordions */

  function initAccordions(root) {
    each(root.querySelectorAll('[data-gc-acc-single]'), function (group) {
      if (!once(group, 'gcAcc')) return;
      var items = group.querySelectorAll('details');
      each(items, function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          each(items, function (o) { if (o !== item) o.open = false; });
        });
      });
    });
  }

  /* ----------------------------------------------------------- reveal */

  function initReveal(root) {
    var nodes = root.querySelectorAll('.gc-reveal:not(.is-in)');
    if (!nodes.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      each(nodes, function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    each(nodes, function (n) { io.observe(n); });
  }

  function init(root) {
    root = root || document;
    initGallery(root);
    initBuyBox(root);
    initEta(root);
    initCompare(root);
    initDemo(root);
    initLoops(root);
    initAccordions(root);
    initReveal(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
